export interface Theme {
  mode: 'light' | 'dark';
  colors: {
    primary: string;
    secondary: string;
    background: string;
    surface: string;
    text: string;
    textSecondary: string;
    accent: string;
    gradientStart: string;
    gradientEnd: string;
    white: string;
    black: string;
    heroPanel: string;
    heroPanelText: string;
    highlight: string;
    muted: string;
    lavender: string;
    stone: string;
    navBackground: string;
    navBorder: string;
    navText: string;
    heroOverlay: string;
    heroText: string;
    heroSubtle: string;
    heroOutline: string;
    cardBackground: string;
    cardBorder: string;
    panelBackground: string;
    panelBorder: string;
    contactCardBackground: string;
    contactCardBorder: string;
    inputBackground: string;
    inputText: string;
    cardShadow: string;
    panelShadow: string;
  };
  fonts: {
    primary: string;
    heading: string;
  };
  breakpoints: {
    mobile: string;
    tablet: string;
    desktop: string;
  };
}

export const lightTheme: Theme = {
  mode: 'light',
  colors: {
    primary: '#ff6b4a',
    secondary: '#f5b84c',
    background: '#FFFFFF',
    surface: '#F5F7FB',
    text: '#1F2937',
    textSecondary: '#4B5563',
    accent: '#00c7a8',
    gradientStart: '#1F2937',
    gradientEnd: '#0F172A',
    white: '#FFFFFF',
    black: '#000000',
    heroPanel: '#1e8bff',
    heroPanelText: '#F1F5F9',
    highlight: '#38bdf8',
    muted: 'rgba(31, 41, 55, 0.7)',
    lavender: '#E0E7FF',
    stone: '#E2E8F0',
    navBackground: '#000000',
    navBorder: '#00c7a8',
    navText: '#F9FAFB',
    heroOverlay: 'linear-gradient(180deg, rgba(17, 25, 40, 0.08) 0%, rgba(17, 25, 40, 0.18) 90%)',
    heroText: '#0F172A',
    heroSubtle: 'rgba(15, 23, 42, 0.7)',
    heroOutline: 'rgba(15, 23, 42, 0.2)',
    cardBackground: 'linear-gradient(145deg, rgba(14, 116, 144, 0.12), rgba(45, 212, 191, 0.08))',
    cardBorder: '#E0F2FE',
    panelBackground: '#F8FAFC',
    panelBorder: '#E2E8F0',
    contactCardBackground: '#FFFFFF',
    contactCardBorder: '#E2E8F0',
    inputBackground: '#FFFFFF',
    inputText: '#1F2937',
    cardShadow: '0 18px 32px rgba(15, 23, 42, 0.08)',
    panelShadow: '0 12px 24px rgba(15, 23, 42, 0.06)',
  },
  fonts: {
    primary: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    heading: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
  },
  breakpoints: {
    mobile: '768px',
    tablet: '1024px',
    desktop: '1280px',
  },
};

export const darkTheme: Theme = {
  mode: 'dark',
  colors: {
    primary: '#ff6b4a',
    secondary: '#f5b84c',
    background: '#040205',
    surface: 'rgba(17, 7, 13, 0.85)',
    text: '#f5f5f7',
    textSecondary: '#d9d5e1',
    accent: '#00c7a8',
    gradientStart: '#0F172A',
    gradientEnd: '#020617',
    white: '#FFFFFF',
    black: '#000000',
    heroPanel: '#1e8bff',
    heroPanelText: '#ffe9a9',
    highlight: '#38bdf8',
    muted: 'rgba(245, 245, 247, 0.65)',
    lavender: '#bac2ff',
    stone: '#1F2937',
    navBackground: 'rgba(10, 4, 8, 0.94)',
    navBorder: '#00c7a8',
    navText: '#F9FAFB',
    heroOverlay: 'linear-gradient(180deg, rgba(4, 2, 5, 0.9) 0%, rgba(4, 2, 5, 0.98) 85%)',
    heroText: '#FFFFFF',
    heroSubtle: 'rgba(255, 255, 255, 0.82)',
    heroOutline: 'rgba(255, 255, 255, 0.35)',
    cardBackground: 'linear-gradient(145deg, rgba(30, 139, 255, 0.25), rgba(0, 199, 168, 0.2))',
    cardBorder: 'rgba(255, 255, 255, 0.12)',
    panelBackground: 'rgba(255, 255, 255, 0.05)',
    panelBorder: 'rgba(255, 255, 255, 0.08)',
    contactCardBackground: 'rgba(255, 255, 255, 0.08)',
    contactCardBorder: 'rgba(255, 255, 255, 0.12)',
    inputBackground: 'rgba(255, 255, 255, 0.1)',
    inputText: '#F9FAFB',
    cardShadow: '0 22px 36px rgba(4, 2, 5, 0.28)',
    panelShadow: '0 18px 30px rgba(4, 2, 5, 0.22)',
  },
  fonts: {
    primary: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    heading: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
  },
  breakpoints: {
    mobile: '768px',
    tablet: '1024px',
    desktop: '1280px',
  },
};
